import React from "react";

import { hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { setupWhitelabelTheme } from "@app/entries/setups/whitelabel-theme";
import configureStore from "@app/modules/account/store/configure-store";
import { acceptHotReplacement } from "@app/utils/hmr";

import "./includes/core-vanilla";
import "./includes/header-desktop";

import { BB, GEO_DATA, middlewares, PROPS } from "./setups/account";
import { ThemeProviderClient } from "../context/theme-provider-client";
import { ForgotPasswordApp } from "../modules/account/components/forgot-password-app";
import { PassengersApp } from "../modules/account/components/passenger-profiles/passengers-app";
import { ResetPasswordApp } from "../modules/account/components/reset-password/reset-password-app";
import { SettingsApp } from "../modules/account/components/settings-app";
import { SigninApp } from "../modules/account/components/sign-in-app";
import { SignupApp } from "../modules/account/components/sign-up-app";
import { TripsApp } from "../modules/account/components/trips";
import { signinMiddleware } from "../modules/account/store/middlewares/signin-middleware";
import ServiceProviderClient from "../services/context-providers/service-provider-client-base";
import sentry from "../services/sentry-facade";
import { authenticationTrackingMiddleware } from "../store/middlewares/authentication-tracking";
import { settingsTrackingMiddleware } from "../store/middlewares/settings-tracking";

let SelectedApp: any;

acceptHotReplacement(module);

switch (PROPS.account_app) {
  case "Settings":
    SelectedApp = SettingsApp;
    middlewares.push(settingsTrackingMiddleware);
    break;
  case "Signin":
    SelectedApp = SigninApp;
    middlewares.push(signinMiddleware, authenticationTrackingMiddleware);
    break;
  case "Signup":
    SelectedApp = SignupApp;
    middlewares.push(signinMiddleware, authenticationTrackingMiddleware);
    break;
  case "Trips":
    SelectedApp = TripsApp;
    break;
  case "Passengers":
    SelectedApp = PassengersApp;
    break;
  case "ResetPassword":
    SelectedApp = ResetPasswordApp;
    break;
  case "ForgotPassword":
    SelectedApp = ForgotPasswordApp;
    break;
}

const INITIAL_STATE = window.__INITIAL_STATE__;
const STORE = configureStore(INITIAL_STATE, middlewares);

const accountApp = (
  <ThemeProviderClient>
    <Provider store={STORE}>
      <ServiceProviderClient
        BB={BB}
        I18N={window.__I18N__}
        REDIRECT={PROPS.redirect_resource}
        sentry={sentry}
        GEO_DATA={GEO_DATA}
      >
        <SelectedApp {...PROPS} />
      </ServiceProviderClient>
    </Provider>
  </ThemeProviderClient>
);

const content = document.getElementById("react-content");

if (SelectedApp && content) {
  setupWhitelabelTheme().then(() => {
    hydrateRoot(content, accountApp);
  });
}
